import React from "react";
import { useSearchFieldStyles } from "./css";
import { SimpleMarkdown } from "../../utils/markdown";
import { useTheme } from "@mui/material";

interface ICellRenderer {
  data: {
    label: string;
    value: string;
  };
  onClick?: (value: string) => {};
}

function SearchField(props: ICellRenderer) {
  const { data, onClick } = props;
  const { classes } = useSearchFieldStyles();
  const theme = useTheme();

  const handleClick = () => {
    if (onClick) onClick(data.value);
  };

  return (
    <div className={classes.container} onClick={handleClick}>
      <div className={classes.top}>{data.value}</div>
      <div className={classes.bottom}>
        <div dangerouslySetInnerHTML={SimpleMarkdown(data.label, theme)} />
      </div>
    </div>
  );
}

export default SearchField;
